"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextContainer = exports.Text = exports.Separator = exports.Country = exports.Container = exports.Bold = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _widths = require("../../../styles/widths");

var _palette = require("../../../styles/palette");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

var Bold = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: ", ";\n"])), _widths.font.medium);

exports.Bold = Bold;
Bold.displayName = 'Bold';

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var Country = _styledComponents["default"].p(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 12px;\n  line-height: 1.67;\n  margin: 0;\n  margin-top: ", "px;\n"])), _widths.widths.base);

exports.Country = Country;
Country.displayName = 'Country';

var Separator = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: rgba(148, 148, 148, 0.3);\n  height: 1px;\n  width: 100%;\n"])));

exports.Separator = Separator;
Separator.displayName = 'Separator';

var Text = _styledComponents["default"].p(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  flex-direction: column;\n  font-size: 14px;\n  line-height: 1.43;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: calc(100vw - 40px);\n"])));

exports.Text = Text;
Text.displayName = 'Text';

var TextContainer = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  margin-left: ", "px;\n"])), _widths.widths.base / 2);

exports.TextContainer = TextContainer;
TextContainer.displayName = 'TextContainer';

var Wrapper = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  min-height: ", "px;\n  padding: ", "px ", "px 0 ", "px;\n  width: 100%;\n\n  & p {\n    font-weight: ", ";\n  }\n  & span {\n    font-weight: ", ";\n  }\n\n  &:hover {\n    background-color: #71aebf;\n    color: ", ";\n    cursor: pointer;\n\n    & p {\n      font-weight: ", ";\n    }\n    & span {\n      font-weight: ", ";\n    }\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), _palette.palette.white, _palette.palette.bobBlack, _widths.widths.base * 8, _widths.widths.base, _widths.widths.base * 2, _widths.widths.base * 2, _widths.font.regular, _widths.font.medium, _palette.palette.white, _widths.font.medium, _widths.font.semi, function (_ref) {
  var featured = _ref.featured;
  return featured && "\n    background-color: #dfeff3;\n    color: #75c0cf;\n\n    & p {\n      font-weight: ".concat(_widths.font.medium, ";\n    }\n    & span {\n      font-weight: ").concat(_widths.font.semi, ";\n    }\n  ");
}, function (_ref2) {
  var selected = _ref2.selected;
  return selected && "\n    background-color: #71aebf;\n    color: ".concat(_palette.palette.white, ";\n\n    & p {\n      font-weight: ").concat(_widths.font.medium, ";\n    }\n    & span {\n      font-weight: ").concat(_widths.font.semi, ";\n    }\n  ");
}, function (_ref3) {
  var topPosition = _ref3.topPosition;
  return topPosition && "\n    position: absolute;\n    top: ".concat(topPosition, "px;\n  ");
});

exports.Wrapper = Wrapper;
Wrapper.displayName = 'Wrapper';